import type { StreamingEvent } from '../../types/chat.types';
import type { ContentProcessorState } from '../contentProcessor.types';

import { createRefGroupDirective } from '../../utils/directives';
import { appendText } from '../nodes';

export function handleTextEvent(
  state: ContentProcessorState,
  event: StreamingEvent<'text'>,
): ContentProcessorState {
  if (!event.data) return state;

  let updatedState = state;
  let textToAppend = event.data;

  const newlineIndex = event.data.indexOf('\n');

  if (state.accumulatedRefIds.length > 0 && newlineIndex !== -1) {
    const beforeNewline = event.data.substring(0, newlineIndex);
    const fromNewline = event.data.substring(newlineIndex);

    const directiveMarkdown = createRefGroupDirective(
      state.accumulatedRefIds.join(','),
    );

    textToAppend = `${beforeNewline}${directiveMarkdown}${fromNewline}`;
    updatedState = {
      ...state,
      accumulatedRefIds: [],
    };
  }

  return {
    ...appendText(updatedState, textToAppend),
    chunks: {
      ...updatedState.chunks,
      progress: [],
      text: [...updatedState.chunks.text, event.data],
    },
  };
}
